import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import ButtonDesigned from '../Buttons/ButtonDesigned';
import React from 'react';

interface IDialogProps {
  title: string;
  text: string;
  isDialogOpen: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
  showCancel?: boolean;
}

export const PopoverConfirmOverlay: React.FC<IDialogProps> = ({
  handleCancel,
  isDialogOpen,
  handleConfirm,
  text,
  title,
  showCancel = true,
}) => {
  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <div className="text-sm text-secondary_text">{text}</div>
      </DialogContent>
      <DialogActions>
        {showCancel && (
          <ButtonDesigned style="outline" onButtonClick={handleCancel} className="text-blue-600">
            Cancel
          </ButtonDesigned>
        )}
        <ButtonDesigned style="primary" onButtonClick={handleConfirm}>
          Confirm
        </ButtonDesigned>
      </DialogActions>
    </Dialog>
  );
};
